import React, { FunctionComponent } from 'react';

import { useSelector } from 'react-redux';

import { NativeAppBanner } from '../../../../../components';
import { ErrorPage } from '../../../../../components/error-page';
import { ErrorPageType } from '../../../../../components/error-page/types';
import { Header } from '../../../../../components/header';
import { selectNewNativeAppBanner2IterationEnabled } from '../../../../flags/selectors';
import { Notifications, Pages } from './components';

interface DefaultViewProps {
    hiddenHeader: boolean;
    withChat?: boolean;
    errorPageType: ErrorPageType | null;
    onCallOverlayHide?: () => void;
    isPlanningDisabled?: boolean;
    shouldShowNativeAppBanner: boolean;
}

export const DefaultView: FunctionComponent<DefaultViewProps> = ({
    hiddenHeader,
    withChat,
    errorPageType,
    onCallOverlayHide,
    isPlanningDisabled,
    shouldShowNativeAppBanner,
}) => {
    const isNewNativeAppBanner2IterationEnabled = useSelector(selectNewNativeAppBanner2IterationEnabled);
    return (
        <>
            {errorPageType ? (
                <>
                    {shouldShowNativeAppBanner && isNewNativeAppBanner2IterationEnabled && <NativeAppBanner />}
                    {errorPageType !== ErrorPageType.UNSUPPORTED_TOUCH && <Header hidden={hiddenHeader} />}
                    <ErrorPage />
                </>
            ) : (
                <>
                    <Header hidden={hiddenHeader} />
                    {shouldShowNativeAppBanner && isNewNativeAppBanner2IterationEnabled && <NativeAppBanner />}
                    <Pages
                        isPlanningDisabled={isPlanningDisabled}
                        onCallOverlayHide={onCallOverlayHide}
                        withChat={withChat}
                    />
                </>
            )}
            <Notifications withChat={withChat} />
        </>
    );
};
